<template>
  <div>
    <h1>Listes</h1>

    <va-card >
    
      <div class="row align--center">
        <div class="flex xs12 md6">
          <va-input
            :value="term"
            :placeholder="$t('tables.searchByName')"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>

        <div class="flex xs12 md3 offset--md3">
          <va-select
            v-model="perPage"
            :label="$t('tables.perPage')"
            :options="perPageOptions"
            noClear
          />
        </div>
      </div>
      
      
      <va-data-table
        :fields="fields"
        :data="filteredData"
        :per-page="parseInt(perPage)"
      >

      <template slot="actions" slot-scope="props">
     
        <va-popover placement="top" title="Edit">
            <va-button @click="editData(props.rowData)" flat small color="gray" icon="fa fa-pencil" />
        </va-popover>
    
      </template> 

      </va-data-table>
  </va-card>

        <va-modal size="large" v-model="showEdit" >
          <div class="ui form">
            <div class="row fields">
            
              <div class="flex xs4 field">
                <div>
                  <h6>Nom </h6>
                  <input 
                    v-model ="lis.label"
                    type="text"
                  >
                </div>
              </div>

              <div class="flex xs4 field">
                <div>
                  <h6>Valeur </h6>
                  <input 
                    v-model  ="lis.value"
                    type="text">
                </div>
              </div>

              <div class="flex xs4 field">
                <div>
                  <h6>Type </h6>
                  <input 
                    v-model ="lis.type"
                    type="text"
                  >
                </div>
              </div>

            </div>


            <div class="row fields">
            
              <div class="flex xs6 field">
                <div>
                  <h6>Code </h6>
                  <input 
                    v-model ="lis.code"
                    type="text"
                  >
                </div>
              </div>

              <div class="flex xs6 field">
                <div>
                  <h6>Enable </h6>
                  <input 
                    v-model="lis.enable"
                    type="boolean"
                  >
                </div>
              </div>

            </div>
            <va-button @click="postEditListData(lis)">Modifier</va-button>
            <va-button >Cancel</va-button>
          </div>
        </va-modal>
        <form class="ui form">
          <h4 class="ui dividing header"> Nouvelle liste</h4> 
          <div class="field">
              <div class="five fields">
                <div class="field">
                  <label>Label</label>
                  <input v-model="ajoutLists.label" type="text" name="label" placeholder="Label" required >
                </div>
                <div class="field">
                  <label>Value</label>
                  <input v-model="ajoutLists.value" type="text" name="value" placeholder="Value">
                </div>
                <div class="field">
                  <label>Type</label>
                  <input v-model="ajoutLists.type" type="text" name="type" placeholder="Type">
                </div>
                <div class="field">
                  <label>Code</label>
                  <input v-model="ajoutLists.code" type="text" name="code" placeholder="Code">
                </div>
                <div class="field radio">
                  <label>Enable</label>

                  <label for="enableTrue">True <input v-model="ajoutLists.enable" type="radio" :value="true" name="enableTrue"></label>
                  
                  <label for="enableFalse">False <input v-model="ajoutLists.enable" type="radio" :value="false" name="enableFalse"></label>
                 
                </div>                
              </div>
          </div>  
          <va-button class="btn" @click.prevent="postList(ajoutLists)">Créer</va-button>
        </form>
  </div>

</template>

<script>
import { debounce } from 'lodash'
import service from "../../providers/service";

export default {
  data () {
    return {
      lis:{},
      ajoutLists:{},
      term: null,
      showEdit:false,
      data : [],
      perPage: '6',
      perPageOptions: ['4', '6', '10']
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'label',
          title: 'Nom',
          sortField: 'label'
        }, 
        {
          name: 'value',
          title: 'Valeur',
          sortField: 'value'
        },
        {
          name: 'type',
          title: 'Type',
          sortField: 'type'
        },
        {
          name: 'code',
          title: 'code',
          sortField: 'code'
        },
        {
          name: 'enable',
          title: 'enable',
          sortField: 'enable'
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }
      ]
    },
     filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.data
      }

      return this.data.filter(item => {
        return item.label.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {
     search: debounce(function (term) {
      this.term = term
    }, 400),


    editData (rowData) {

      this.lis = rowData;

      this.showEdit = true;
    },


    postEditListData :function (data) {
      console.log(data)
     service.postEditeList(data.id, localStorage.userAccesstoken, data).then(res=>{
       if (res.status==200) {
         this.showEdit = false;
           alert('Modification réussie');
         
       }
     })
    },
    
    postList:function(data) {

      service.postLists(localStorage.userAccesstoken, data)

      this.ajoutLists={},

      this.getList();
    },


    getList(){

      service.getLists(localStorage.userAccesstoken).then( res => {

        if(res.status === 200){
          this.data = res.data;
        }
      })
    }
  },
  mounted(){
     this.getList(); 
  }
}
</script>

<style lang="scss">
.ui.dividing.header {
    margin-top: 2em !important;
}

.btn{
  width: 9rem;
  height: 3rem;
  font-size: 20px !important;
}

</style>